import { Action } from '@ngrx/store';

export enum TeamActionTypes {
  GET_TEAMS = '[Teams] GET',
  GET_TEAMS_SUCCESS = '[Teams] GET Success',
  GET_TEAMS_FAILURE = '[Teams] GET Failure',

  GET_TEAM_MEMBERS = '[Teams] GET Members',
  GET_TEAM_MEMBERS_SUCCESS = '[Teams] GET Members Success',
  GET_TEAM_MEMBERS_FAILURE = '[Teams] GET Members Failure',

  SET_TEAM = '[Team] SET Team',
  SET_TEAM_SUCCESS = '[Team] SET Team Success',
  SET_TEAM_FAILURE = '[Team] SET Team Failure',

  EDIT_TEAM = '[Team] EDIT Team',
  CREATE_TEAM = '[Team] CREATE Team',

  UPDATE_TEAM = '[Team] UPDATE Team',
  UPDATE_TEAM_SUCCESS = '[Team] UPDATE Team Success',
  UPDATE_TEAM_FAILURE = '[Team] UPDATE Team Failure',

  ADD_TEAM_MEMBER = '[Team] ADD Member',
  ADD_TEAM_MEMBER_SUCCESS = '[Team] ADD Member Success',
  ADD_TEAM_MEMBER_FAILURE = '[Team] ADD Member Failure',

  REMOVE_TEAM_MEMBER = '[Team] REMOVE Member',
  REMOVE_TEAM_MEMBER_SUCCESS = '[Team] REMOVE Member Success',
  REMOVE_TEAM_MEMBER_FAILURE = '[Team] REMOVE Member Failure',

}

// TEAMS
export class GetTeams implements Action {
  readonly type = TeamActionTypes.GET_TEAMS;
  constructor(public payload: any) {}
}
export class GetTeamsSuccess implements Action {
  readonly type = TeamActionTypes.GET_TEAMS_SUCCESS;
  constructor(public payload: any) {}
}
export class GetTeamsFailure implements Action {
  readonly type = TeamActionTypes.GET_TEAMS_FAILURE;
  constructor(public payload: any) {}
}

export class GetTeamMembers implements Action {
  readonly type = TeamActionTypes.GET_TEAM_MEMBERS;
  constructor(public payload: any) {}
}
export class GetTeamMembersSuccess implements Action {
  readonly type = TeamActionTypes.GET_TEAM_MEMBERS_SUCCESS;
  constructor(public payload: any) {}
}
export class GetTeamMembersFailure implements Action {
  readonly type = TeamActionTypes.GET_TEAM_MEMBERS_FAILURE;
  constructor(public payload: any) {}
}

export class AddTeamMember implements Action {
  readonly type = TeamActionTypes.ADD_TEAM_MEMBER;
  constructor(public payload: any) {}
}
export class AddTeamMemberSuccess implements Action {
  readonly type = TeamActionTypes.ADD_TEAM_MEMBER_SUCCESS;
  constructor(public payload: any) {}
}
export class AddTeamMemberFailure implements Action {
  readonly type = TeamActionTypes.ADD_TEAM_MEMBER_FAILURE;
  constructor(public payload: any) {}
}

export class RemoveTeamMember implements Action {
  readonly type = TeamActionTypes.REMOVE_TEAM_MEMBER;
  constructor(public payload: any) {}
}
export class RemoveTeamMemberSuccess implements Action {
  readonly type = TeamActionTypes.REMOVE_TEAM_MEMBER_SUCCESS;
  constructor(public payload: any) {}
}
export class RemoveTeamMemberFailure implements Action {
  readonly type = TeamActionTypes.REMOVE_TEAM_MEMBER_FAILURE;
  constructor(public payload: any) {}
}

// TEAM
export class EditTeam implements Action {
  readonly type = TeamActionTypes.EDIT_TEAM;
  constructor(public payload: any) {}
}
export class CreateTeam implements Action {
  readonly type = TeamActionTypes.CREATE_TEAM;
  constructor(public payload: any) {}
}

// Update Team
export class UpdateTeam implements Action {
  readonly type = TeamActionTypes.UPDATE_TEAM;
  constructor(public payload: any) {}
}
export class UpdateTeamSuccess implements Action {
  readonly type = TeamActionTypes.UPDATE_TEAM_SUCCESS;
  constructor(public payload: any) {}
}
export class UpdateTeamFailure implements Action {
  readonly type = TeamActionTypes.UPDATE_TEAM_FAILURE;
  constructor(public payload: any) {}
}

export class SetTeam implements Action {
  readonly type = TeamActionTypes.SET_TEAM;
  constructor(public payload: any) {}
}
export class SetTeamSuccess implements Action {
  readonly type = TeamActionTypes.SET_TEAM_SUCCESS;
  constructor(public payload: any) {}
}
export class SetTeamFailure implements Action {
  readonly type = TeamActionTypes.SET_TEAM_FAILURE;
  constructor(public payload: any) {}
}


export type All =
  | GetTeams
  | GetTeamsSuccess
  | GetTeamsFailure
  | GetTeamMembers
  | GetTeamMembersSuccess
  | GetTeamMembersFailure
  | EditTeam
  | CreateTeam
  | SetTeam
  | SetTeamSuccess
  | SetTeamFailure
  | AddTeamMember
  | AddTeamMemberSuccess
  | AddTeamMemberFailure
  | RemoveTeamMember
  | RemoveTeamMemberSuccess
  | RemoveTeamMemberFailure
  | UpdateTeam
  | UpdateTeamSuccess
  | UpdateTeamFailure



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/pmclient-uat/src/app/store/actions/team.actions.ts